import { useMemo } from 'react';
import createAppTheme from './index';

/**
 * Custom hook to use the application theme
 * @returns {Object} Theme object
 */
export const useAppTheme = () => {
  // Create the theme
  const theme = useMemo(() => createAppTheme(), []);

  return {
    theme,
    themeMode: 'light'
  };
};

export default useAppTheme;
